
/**
 * Extracts the fqn part from a path, where fqn represents
 * tenant/roomName.
 *
 * @param {string} path - The URL path.
 * @returns {string}
 */
export function extractFqnFromPath(state?: Object) {
    // const parts = path.split('/');
    // const len = parts.length;

    // return parts.length > 2 ? `${parts[len - 2]}/${parts[len - 1]}` : '';
    let pathname;

    if (window.location.pathname) {
        pathname = window.location.pathname;
    } else if (state?.['features/base/connection']) {
        pathname = state['features/base/connection'].locationURL?.pathname ?? '';
    } else {
        return '';
    }

    const parts = pathname.split('/');
    const len = parts.length;

    return parts.length > 2 ? `${parts[len - 2]}/${parts[len - 1]}` : parts[1];
}

/**
 * Returns the url used for fetching dynamic branding.
 *
 * @param {Object} state - The state of the app.
 * @returns {string}
 */
export function getDynamicBrandingUrl(state: Object) {
    const { dynamicBrandingUrl } = state['features/base/config'];

    if (dynamicBrandingUrl) {
        return dynamicBrandingUrl;
    }

    const baseUrl = state['features/base/config'].brandingDataUrl;
    const fqn = extractFqnFromPath(state['features/base/connection'].locationURL.pathname);

    if (baseUrl && fqn) {
        return `${baseUrl}?conferenceFqn=${encodeURIComponent(fqn)}`;
    }
}
